import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask'; 
import {DropdownModule} from 'primeng/dropdown'
import { SpinnerModule } from 'primeng/spinner';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PaginatorModule } from 'primeng/paginator'; // grid pagination
import { PanelModule } from 'primeng/panel'; //  for panel view
import { TabViewModule } from 'primeng/tabview'; //  for tabs view
import { TooltipModule } from 'primeng/tooltip'; //  to add tooltip on field
import { AccordionModule } from 'primeng/accordion'; /// just popup without fotter buttons
import { TableModule } from 'primeng/table'; // grid
import { DialogModule } from 'primeng/primeng';
import { ChartModule} from 'primeng/chart';
import { CardModule } from 'primeng/card';
import {EditorModule} from 'primeng/editor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InputMaskModule,
    InputTextModule,
    DropdownModule,
    SpinnerModule,
    ProgressSpinnerModule,
    PaginatorModule,
    PanelModule,
    TabViewModule,
    TooltipModule,
    AccordionModule,
    TableModule,
    ChartModule,
    CardModule,
    EditorModule,
    DialogModule
  ],
  exports: [
    InputTextModule,
    InputMaskModule,
    DropdownModule,
    SpinnerModule,
    ProgressSpinnerModule,
    TabViewModule,
    PaginatorModule,
    PanelModule,
    TableModule,
    TooltipModule,
    AccordionModule,
    ChartModule,
    CardModule,
    EditorModule,
    DialogModule
  ],
  providers: []
})
export class PrimeNgComponentsModule { }
